<script>
import { breadcrumbEventBus } from '@/main'
import LiveReportService from '@/services/ReportModules/LiveReportService'
import salesCheckListModal from '@/components/modals/sales/salesCheckListModal'

export default {
  components: {
    salesCheckListModal
  },
  created () {
    this.location_id = this.$route.params.location_id
  },
  data () {
    return {
      location: {},
      ticketSummary: {
        checks: []
      },
      expanded: true
    }
  },
  mounted () {
    this.$updateloading(2)
    LiveReportService.getLocationOpenTickets(this.location_id).then(data => {
      this.ticketSummary = data
      this.$updateloading(-1)
    })
    LiveReportService.getLocation(this.location_id).then(data => {
      this.location = data
      this.setBreadcrumb()
      this.$updateloading(-1)
    })
  },
  methods: {
    getTotalPerGuest: function (ticket) {
      return Math.round(ticket.total * 100 / ticket.guestcount) / 100
    },
    setBreadcrumb: function () {
      const breadcrumb = []
      breadcrumb.push({ link: '/live/home', title: 'Home' })
      breadcrumb.push({
        link: '/live/location/' + this.location_id,
        title: this.location.name
      })
      breadcrumb.push({ link: null, title: 'Tickets' })
      breadcrumbEventBus.$emit('breadcrumbChanged', breadcrumb)
    }
  }
}
</script>

<template>
  <div class="card">
    <div class="card-header list-group-item active">
      <div class="list-group-item-heading float-left "><strong>Open Tickets</strong></div>
      <div class="list-group-item-heading float-right ">
        <a
          href="javascript:void(0)"
          v-on:click="expanded = !expanded"
        >
          <i
            class="fas fa-minus-square"
            v-show="expanded"
          ></i>
          <i
            class="fas fa-plus-square"
            v-show="!expanded"
          ></i>
        </a>
      </div>
    </div>
    <div
      class="card-body table-responsive"
      v-show="expanded"
    >
      <table class="table table-bordered table-striped table-sm">
        <thead class="table-header header">
          <tr>
            <th>Ticket #</th>
            <th>Employee</th>
            <th>Table #</th>
            <th class="text-center">Started</th>
            <th class="text-center">Guests</th>
            <th class="text-right">Voids/Discounts</th>
            <th class="text-right">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="ticketSummary.checks.length == 0">
            <td
              colspan="7"
              class="text-center"
            >No open tickets</td>
          </tr>
          <tr
            v-show="ticketSummary.checks.length > 0"
            v-for="(t, tindex) in ticketSummary.checks"
            :key="tindex"
          >
            <td>
              <sales-check-list-modal
                :locationId="location_id"
                :checkId="t.id"
                :inday="true"
              >
                {{ t.checknumber }}
              </sales-check-list-modal>
            </td>
            <td>{{ t.employee }}</td>
            <td>{{ t.tablenumber }}</td>
            <td class="text-center">{{ t.opened }}</td>
            <td class="text-center">{{ t.guestcount }} ({{ getTotalPerGuest(t) | currency }}/ea)</td>
            <td class="text-right">{{ t.voids | currency }} / {{ t.discounts | currency }}</td>
            <td class="text-right">{{ t.total | currency }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped>
</style>
